import { isUndefined, omitBy } from 'lodash'
import { useCallback } from 'react'

import { Status, useFetchRefactored } from 'civic-champs-shared/api/hooks'
import { useCurrentOrg } from 'auth/hooks'
import { RegistrantResponse } from 'Event/interfaces'
import { useFeatureEnabled } from 'core/feature/hooks'

export interface RegistrantsQuery {
  occurrenceId?: number
  personId?: number
  date?: Date
  includeVolunteerTags?: boolean
}

export const useGetRegistrants = (): [
  (query: RegistrantsQuery) => Promise<RegistrantResponse[]>,
  Status<RegistrantResponse[]>,
] => {
  const isVolunteerTagsEnabled = useFeatureEnabled('RegistrationVolunteerTags')
  const organization = useCurrentOrg()
  const [request, status] = useFetchRefactored<RegistrantResponse[]>()

  const getRegistrants = useCallback(
    (query: RegistrantsQuery) => {
      const { occurrenceId, personId, date, includeVolunteerTags: queryTags } = query

      const includeVolunteerTags = queryTags === true ? 'true' : queryTags === false ? 'false' : undefined

      return request({
        method: 'get',
        url: `/organizations/${organization.id}/registrants`,
        config: {
          queryStringParameters: omitBy(
            {
              occurrenceId,
              personId,
              date: date ? date.toISOString() : undefined,
              includeVolunteerTags: isVolunteerTagsEnabled ? includeVolunteerTags : undefined,
            },
            isUndefined,
          ),
        },
      })
    },
    [isVolunteerTagsEnabled, organization.id, request],
  )

  return [getRegistrants, status]
}
